<template>
	<div class="switch-view" :style="_style" @click="click">
		<div v-if="label" class="label" :style="_labelStyle">{{ label }}</div>
		<div class="switch" :style="_switchStyle">
			<div class="knob" :style="_knobStyle"></div>
		</div>
	</div>
</template>

<script>
	import theme from '@/mixins/theme';

	export default {
		mixins: [theme],
		props: {
			value: {
				type: [Boolean, Array],
				default: false
			},
			label: {
				type: String,
				default: null
			},
			colors: {
				type: Object,
				default() {
					return {};
				}
			},
			group: {
				type: [Number, String],
				default: null
			}
		},
		methods: {
			click() {
				var val;

				if (this.group === null) {
					val = !this.value;
				} else {
					val = Array.from(this.value);

					if (this._on) {
						const idx = val.indexOf(this.group);
						val.splice(idx, 1);
					} else {
						val.push(this.group);
					}
				}

				this.$emit('input', val);
			}
		},
		computed: {
			_on() {
				return this.group === null ? (this.value) : (this.value.includes(this.group));
			},
			_colors() {
				return {
					...{
						knobOff: 		this.theme.colors.surface,
						knobOn: 		this.theme.colors.surface,
						backgroundOff:	this.theme.colors.backgroundShadow,
						backgroundOn:	this.theme.colors.primary,
						labelOff:		this.theme.colors.onBackgroundVariant,
						labelOn:		this.theme.colors.onBackground
					},
					...this.colors
				};
			},
			_style() {
				return {
					width:					this.label ? '200px' : '36px',
					gridTemplateColumns: 	this.label ? '1fr 36px' : '1fr'
				};
			},
			_labelStyle() {
				return {
					...this.theme.typography.caption,
					...{
						transition: 		'color 300ms ' + this.theme.transitions.cubic,
						color: 				this._on ? this._colors.labelOn : this._colors.labelOff
					}
				};
			},
			_switchStyle() {
				return {
					...{
						transition: 		'background-color 300ms ' + this.theme.transitions.cubic,
						backgroundColor: 	this._on ? this._colors.backgroundOn : this._colors.backgroundOff,
					}
				};
			},
			_knobStyle() {
				return {
					...{
						transition: 		'left 300ms ' + this.theme.transitions.cubic + ', background-color 300ms ' + this.theme.transitions.cubic,
						backgroundColor: 	this.value ? this._colors.knobOn : this._colors.knobOff,
						left: 				this._on ? '18px' : '2px'
					}
				};
			}
		}
	}
</script>

<style lang="scss" scoped>
	.switch-view {
		box-sizing: border-box;
		display: grid;
		cursor: pointer;

		& > .label {
			line-height: 20px;
		}

		& > .switch {
			height: 20px;
			position: relative;
			padding: 2px;
			border-radius: 10px;
			box-sizing: border-box;
			box-sizing: border-box;
			width: 100%;

			& > .knob {
				position: absolute;
				top: 2px;
				width: 16px;
				height: 16px;
				border-radius: 8px;
			}
		}
	}
</style>